module.exports = __webpack_public_path__ + "static/assets/a4f9465e6b98af7253054dd858fde1d5.svg";